<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandleSlave from "../DesignerQuestionHardwareHandleSlave.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandleSlave,
            TileQuestion
        ],
        props: {
            title: {
                default() {
                    return 'Select Your Door Handle';
                }
            }
        },
        computed: {
            panel_required() {
                return this.filtered_option_list.length > 1;
            }
        }
    }
</script>
